<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5041)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5041)" />
    </g>
    <path
      d="M10.9999 14.0027H10.3333V12.6667H11.6693V14.0027H11.0026H10.9999ZM10.9999 18.6693H10.3333V17.3333H11.6693V18.6693H11.0026H10.9999ZM10.3333 23.336H11.6693V22H10.3333V22.6693V23.336ZM14.3333 12.6667H13.6666V14H23.6666V12.6667H22.9999H14.3333ZM13.6666 17.3333H23.6666V18.6667H13.6666V17.3333ZM14.3333 22H13.6666V23.3333H23.6666V22H22.9999H14.3333Z"
      fill="white" />
    <defs>
      <filter id="filter0_d_3254_5041"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.611765 0 0 0 0 0 0 0 0 0 0.439216 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5041" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5041" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5041"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#DE006B" />
        <stop offset="1" stop-color="#9C0070" />
      </linearGradient>
    </defs>
  </svg>
</template>
